module.exports = __webpack_public_path__ + "static/nplogofm-8c9ccaa788042010be27cba8403d212e.jpg";